import React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: any;
};

function Header({ children }: Props) {
  return <Container>{children}</Container>;
}

export default Header;

const Container = styled('div')`
  text-align: center;
  font-weight: bold;
  color: #fff;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -8px;
  width: 100%;
`;
